import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=55887390&scoped=true&"
import script from "./PolicyInfo.vue?vue&type=script&lang=js&"
export * from "./PolicyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=55887390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55887390",
  null
  
)

export default component.exports